export default "__VITE_ASSET__G33QrZFS__"